import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
import { Link } from "gatsby";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import SectionBasics from "./Sections/SectionBasics.jsx";
import SectionNavbars from "./Sections/SectionNavbars.jsx";
import SectionTabs from "./Sections/SectionTabs.jsx";
import SectionPills from "./Sections/SectionPills.jsx";
import SectionNotifications from "./Sections/SectionNotifications.jsx";
import SectionTypography from "./Sections/SectionTypography.jsx";
import SectionJavascript from "./Sections/SectionJavascript.jsx";
import SectionCarousel from "./Sections/SectionCarousel.jsx";
import SectionCompletedExamples from "./Sections/SectionCompletedExamples.jsx";
import SectionLogin from "./Sections/SectionLogin.jsx";
import SectionExamples from "./Sections/SectionExamples.jsx";
import SectionDownload from "./Sections/SectionDownload.jsx";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";

import logo from "assets/img/logo.png";

const preStyle = {
  overflowX: 'scroll',
  backgroundColor: '#363636',
  color: '#f2f2f2',
  lineHeight: '3',
  borderRadius: '4px',
  padding: '0 2em'
}

class Components extends React.Component {
  state = {
      classicModal: false
    };

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          brand={(
            <img
              height={50}
              src={logo}
              alt="..."
              className={
                classes.imgRaised +
                " " +
                classes.imgRounded +
                " " +
                classes.imgFluid
              }
            />
          )}
          rightLinks={<HeaderLinks />}
          fixed
          color="transparent"
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
        <Parallax image={require("assets/img/rg-bg-0.jpeg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Racer Gear II.</h1>
                  <h3 className={classes.subtitle}>
                    2D Game with a flight of fancy 3D.
                  </h3>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.section}>
            <div className={classes.container}>
              <GridContainer className={classes.textJustify}>
                <GridItem xs={12} sm={12} md={12}>
                  <h2>Description</h2>
                  <h4>
                    RaceGear is a 2D Game with a flight of fancy 3D programed in C++ using
                    <a
                      href="https://github.com/Rosalila/RosalilaEngine"
                      target="_blank"
                    >
                      {" "}Rosalila Engine 2{" "}
                    </a>
                    library.
                  </h4>
                </GridItem>
                <GridItem xs={12} sm={8} md={12}>
                  <h4>
                    Rosalila Engine 2 has some dependencies such as SDL2 library and OpenGL, you'll need them if you want to play our game.
                SDL2 and OpenGL are easy to install typing this comands:
                  </h4>
                </GridItem>
                <GridItem>
                  <pre style={preStyle}>apt-get install libsdl2-dev libsdl2-image-dev libsdl2-mixer-dev libsdl2-ttf-dev freeglut3-dev</pre>
                  <h4>
                    As next point, link the libraries: In Code::Blocks: "Linker settings" -> "Other linker options" Add the following:
                  </h4>
                  <pre style={{...preStyle, lineHeight: undefined, overflowX: undefined}}>{`
    -lGL
    -lglut
    -lGLU
    -lSDL2
    -lSDL2_image
    -lSDL2_ttf
    -lSDL2_mixer
                  `}</pre>
                </GridItem>
              </GridContainer>
            </div>
          </div>

          <SectionTypography />
          <SectionNavbars />

          {/*<SectionBasics />
          <SectionTabs />
          <SectionPills />
          <SectionNotifications />
          <SectionJavascript />
          <SectionCarousel />
          <SectionCompletedExamples />
          <SectionLogin />
          <GridItem md={12} className={classes.textCenter}>
            <Link to={"/login-page"} className={classes.link}>
              <Button color="primary" size="lg" simple>
                View Login Page
              </Button>
            </Link>
          </GridItem>
          <SectionExamples />
          <SectionDownload />*/}
        </div>
        <Footer handleClickOpen={this.handleClickOpen} handleClose={this.handleClose} classicModal={this.state.classicModal} />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(Components);
